/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModoAplicacionEnum } from 'config/instrumentos';
import { Estudiante_Updated_Notificacion } from 'generated/graphql';

interface ChannelMessage {
	type: 'actividad' | 'instrumento';
	tipoActividad: string;
	modoAplicacion?: string;
	message: string;
	timestamp: string;
}

interface IsEstudianteUpdateI {
	entity: Estudiante_Updated_Notificacion | null;
	isModalOpen: boolean;
	isUpdated: boolean | null;
	message?: string | null;
	typeMessage?: string | null;
	// Nuevos campos para manejar mensajes por canal
	channelMessages: {
		[key: string]: ChannelMessage[]; // key puede ser actividadKey, actividadRubricaKey, o rutaSesionKey
	};
	dismissedChannels: string[]; // Canales que el usuario ya cerró
}

const initialState: IsEstudianteUpdateI = {
	isUpdated: false,
	isModalOpen: false,
	entity: null,
	channelMessages: {},
	dismissedChannels: []
};

const isEstudianteUpdatedStateSlice = createSlice({
	name: 'isEstudianteUpdatedState',
	initialState,
	reducers: {
		setIsEstudianteUpdatedStateSlice: (state, action: PayloadAction<IsEstudianteUpdateI>) => {
			return action.payload;
		},
		updateModalIsEstudianteUpdatedStateSlice: (state, action) => {
			const isModalOpen = action.payload;
			return { ...state, isModalOpen };
		}, // Nuevo: Agregar mensaje de canal
		addChannelMessage: (
			state,
			action: PayloadAction<{
				channelKey: string;
				channelType: 'actividad' | 'instrumento';
				tipoActividad: string;
				message: string;
				modoAplicacion?: string;
			}>
		) => {
			const { channelKey, channelType, tipoActividad, message, modoAplicacion } = action.payload;

			if (!state.channelMessages[channelKey]) {
				state.channelMessages[channelKey] = [];
			}

			// Evitar duplicados del mismo tipo
			const existingIndex = state.channelMessages[channelKey].findIndex(
				(msg) => msg.type === channelType && msg.tipoActividad === tipoActividad
			);

			const newMessage: ChannelMessage = {
				type: channelType,
				tipoActividad,
				message,
				timestamp: new Date().toISOString(),
				modoAplicacion
			};

			if (existingIndex >= 0) {
				state.channelMessages[channelKey][existingIndex] = newMessage;
			} else {
				state.channelMessages[channelKey].push(newMessage);
			}

			// Remover de dismissed si existe (usando array)
			const dismissedIndex = state.dismissedChannels.indexOf(channelKey);
			if (dismissedIndex > -1) {
				state.dismissedChannels.splice(dismissedIndex, 1);
			}
		},
		// Nuevo: Marcar canal como cerrado
		dismissChannel: (state, action: PayloadAction<string>) => {
			const channelKey = action.payload;
			if (!state.dismissedChannels.includes(channelKey)) {
				state.dismissedChannels.push(channelKey);
			}
		},
		// Nuevo: Limpiar mensajes de canal específico
		clearChannelMessages: (state, action: PayloadAction<string>) => {
			const channelKey = action.payload;
			delete state.channelMessages[channelKey];
			const dismissedIndex = state.dismissedChannels.indexOf(channelKey);
			if (dismissedIndex > -1) {
				state.dismissedChannels.splice(dismissedIndex, 1);
			}
		},
		// Nuevo: Limpiar todos los mensajes (al cambiar de contexto)
		clearAllChannelMessages: (state) => {
			state.channelMessages = {};
			state.dismissedChannels = [];
		}
	}
});

export const selectPendingChannelMessages = (state: any) => {
	const estudianteState = state.isEstudianteUpdatedState;
	const pendingMessages: { [key: string]: ChannelMessage[] } = {};

	Object.entries(estudianteState.channelMessages).forEach(([channelKey, messages]) => {
		const channelMessages = messages as ChannelMessage[];
		if (!estudianteState.dismissedChannels.includes(channelKey) && channelMessages.length > 0) {
			pendingMessages[channelKey] = channelMessages;
		}
	});

	return pendingMessages;
};

export const selectChannelMessageSummary = (state: any) => {
	const pendingMessages = selectPendingChannelMessages(state);
	const summary: string[] = [];

	Object.values(pendingMessages).forEach((messages: ChannelMessage[]) => {
		messages.forEach((msg) => {
			if (msg.type === 'actividad') {
				summary.push(`Se ha publicado una actividad ${msg.tipoActividad}, actualiza para verla`);
			} else if (msg.type === 'instrumento') {
				summary.push(
					`Se ha publicado una ${
						msg.modoAplicacion === ModoAplicacionEnum.coevaluacion
							? 'coevaluación'
							: msg.modoAplicacion === ModoAplicacionEnum.heteroevaluacion
							? 'evaluación'
							: 'autoevaluación'
					} ${msg.tipoActividad === 'grupal' ? 'de equipo' : 'individual'}, actualiza para verla.`
				);
			}
		});
	});

	return summary;
};

export const {
	setIsEstudianteUpdatedStateSlice,
	updateModalIsEstudianteUpdatedStateSlice,
	addChannelMessage,
	dismissChannel,
	clearChannelMessages,
	clearAllChannelMessages
} = isEstudianteUpdatedStateSlice.actions;

export default isEstudianteUpdatedStateSlice.reducer;

// import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Estudiante_Updated_Notificacion } from 'generated/graphql';

// interface IsEstudianteUpdateI {
// 	entity: Estudiante_Updated_Notificacion | null;
// 	isModalOpen: boolean;
// 	isUpdated: boolean | null;
// 	message?: string | null;
// 	typeMessage?: string | null;
// }

// const initialState: IsEstudianteUpdateI = { isUpdated: false, isModalOpen: false, entity: null };

// const isEstudianteUpdatedStateSlice = createSlice({
// 	name: 'isEstudianteUpdatedState',
// 	initialState,
// 	reducers: {
// 		setIsEstudianteUpdatedStateSlice: (state, action: PayloadAction<IsEstudianteUpdateI>) => {
// 			return action.payload;
// 		},
// 		updateModalIsEstudianteUpdatedStateSlice: (state, action) => {
// 			const isModalOpen = action.payload;
// 			return { ...state, isModalOpen };
// 		}
// 	}
// });

// export const { setIsEstudianteUpdatedStateSlice, updateModalIsEstudianteUpdatedStateSlice } =
// 	isEstudianteUpdatedStateSlice.actions;

// export default isEstudianteUpdatedStateSlice.reducer;
